import { authorize, deleteRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function deleteZoneAPI(id) {
  const url = `${AWS_API_URL}/2n/zones/${id}`;
  return deleteRequest(url, await authorize());
}

